// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
//@actions
const signaturePatternActions = require('actions/signaturePattern');
//@constants
const actionTypes = require('constants/actionTypes');
const { FIRST_STEP } = require('constants/index');

function setupFirstStep(data) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHECKS_SETUP_FIRST_STEP,
        payload: {
            data
        }
    }
}

function setVisibleStep(step) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHECKS_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function validateWithUI(step) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHECKS_VALIDATE_STEP,
        payload: {
            step
        }
    }
}

const validateWithAPIRequest = () => ({
    type: actionTypes.ACCOUNT_CANCEL_CHECKS_VALIDATE_API_REQUEST
});

const validateWithAPISuccess = (response, accountId, chequebookId, chequeNumber) => ({
    type: actionTypes.ACCOUNT_CANCEL_CHECKS_VALIDATE_API_SUCCESS,
    payload: {
        response,
        accountId,
        chequebookId,
        chequeNumber
    }
});

const validateWithAPIFailure = () => ({
    type: actionTypes.ACCOUNT_CANCEL_CHECKS_VALIDATE_API_FAILURE
});

const validateWithAPI = () => (dispatch, getState) => {
    const immStep = getState().accountCancelCheques.getIn(['steps', FIRST_STEP]);
    const accountId = immStep.get('accountId');
    const chequebookIndex = immStep.get('chequebookIndex');
    const chequeNumber = immStep.get('number');
    const immCheques = getState().accountsCheques.get(accountId);
    const chequebookId = immCheques.get('byOrder').get(chequebookIndex);
    const immChequebook = immCheques.get('byId').get(chequebookId);
    const immAccount = getState().accounts.get('byId').get(accountId);
    const requestData = {
        query: {
            producto: immAccount.get('newProduct'),
            contrato: immAccount.get('newContractNumber'),
            codMoneda: immChequebook.get('currency'),
            numChequeInicial: immChequebook.get('initialNum'),
            indicadorSituacion: 'A',
            numChequeBusqueda: chequeNumber
        }
    };

    dispatch(validateWithAPIRequest());

    return APIGet({
        dispatch,
        endpoint: 'accountChequebook',
        url: apiURLBuilder.getURL('accountChequebook'),
        params: requestData
    })
    .then(response => dispatch(validateWithAPISuccess(response, accountId, chequebookId, chequeNumber)))
    .catch(() => dispatch(validateWithAPIFailure()));
}

const validateStep = step => (dispatch, getState) => {
    dispatch(validateWithUI(step));

    const cancelChequesFirstStep = getState().accountCancelCheques.getIn(['steps', FIRST_STEP]);
    const isValidUI = cancelChequesFirstStep.get('isValidUI');

    if (isValidUI) {
        dispatch(validateWithAPI());
    }
}

function setWillCancel(willCancel) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHECKS_WILL_CANCEL,
        payload: {
            willCancel
        }
    };
}

function resetView() {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHECKS_RESET_VIEW
    };
}

function numberChanged(number) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHECKS_CHEQUE_CHANGED,
        payload: {
            number
        }
    };
}

function amountChanged(amount) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHECKS_AMOUNT_CHANGED,
        payload: {
            amount
        }
    };
}

function reasonChanged(value) {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHECKS_REASON_CHANGED,
        payload: {
            value
        }
    };
}

function successCancelCheques() {
    return {
        type: actionTypes.ACCOUNT_CANCEL_CHECKS_SUCCESS
    };
}

const cancelChequeFailure = (error) => ({
    type: actionTypes.ACCOUNT_CANCEL_CHEQUE_FAILURE,
    payload: {
        error
    }
});

const cancelCheque = (accountId) => (dispatch, getState) => {

    const callback = (dispatch, getState, dataToken) => {
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const currency = immAccount.getIn(['balance', 'currency']);
        const newProduct = immAccount.get('newProduct');
        const newContractNumber = immAccount.get('newContractNumber');

        const cancelChequesFirstStep = getState().accountCancelCheques.get('steps').get(0);
        const amount = cancelChequesFirstStep.get('amount');
        const chequeNumber = cancelChequesFirstStep.get('number');
        const newSituation = cancelChequesFirstStep.get('reason');

        const params = {
            query: {
                dataToken,
                cantidadCheques: 1,
                codMoneda: currency,
                datosConexion: {
                    contrato: {
                        numerodecontrato: newContractNumber ,
                        producto: newProduct
                    }
                },
                importe: {
                    divisa: currency,
                    importe: amount, // UI
                },
                moneda: currency,
                newSit: newSituation, // UI
                numeroCheque: chequeNumber, //UI
            }
        };

        APIPost(dispatch, apiURLBuilder.getURL('accountCancelCheque'), params)
            .then(response => dispatch(successCancelCheques(response)))
            .catch(error => dispatch(cancelChequeFailure(error)));
    };

    return Promise.resolve().then(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    setVisibleStep,
    validateStep,
    setWillCancel,
    cancelCheque,
    resetView,
    setupFirstStep,
    numberChanged,
    amountChanged,
    reasonChanged
}
